export default __webpack_public_path__ + "static/media/gallery_01.7fd19919.jpg";